const EU28ICO: string[] = [
  'AT', // Австрия
  'BE', //Бельгия
  'BG', // Болгария
  'HU', // Венгрия
  'GR', //Греция
  'DE', //Германия
  'DK', //Дания
  'IT', //Италия
  'IE', //Ирландия
  'ES', //Испания
  'CY', //Кипр
  'LU', //Люксенбург
  'LV', //Латвия
  'LT', //Литва
  'MT', //Мальта
  'NL', //Нидерланды
  'PT', //Португалия
  'PL', //Польша
  'RO', //Румыния
  'SI', //Словения
  'SK', //Словакия
  'FR', //Франция
  'FI', //Финляндия
  'HR', //Хорватия
  'CZ', //Чехия
  'SE', //Швеция
  'EE', //Эстония
]

const EU28MOK: string[] = [
  'AUT',  // Австрия
  'BEL', //Бельгия
  'BUL', //Болгария
  'HUN', //Венгрия
  'CRE', //Греция
  'GER', //Германия
  'DEN', //Дания
  'ITA', //Италия
  'IRL', //Ирландия
  'ESP', //Испания
  'CYP', //Кипр
  'LUX', //Люксенбург
  'LAT', //Латвия
  'LTU', //Литва
  'MLT', //Мальта
  'NED', //Нидерланды
  'POR', //Португалия
  'POL', //Польша
  'ROU', //Румыния
  'SLO', //Словения
  'SVK', //Словакия
  'FRA', //Франция
  'FIN', //Финляндия
  'CRO', //Хорватия
  'CZE', //Чехия
  'SWE', //Швеция
  'EST', //Эстония
]

export function checkEU28(codeISOorMOK: string) {
  return [...EU28ICO, ...EU28MOK].map(e => e.toUpperCase()).includes(codeISOorMOK?.toUpperCase());
}